<template>
  <tooltip
    :delay="500"
    placement="top"
    :content="tooltipText"
    max-width="200"
  >
    <div class="collapsed-job-types">
      <tag
        color="default"
        v-for="(type, i) in filteredJobTypes"
        :key="type + i"
      >
        {{ type }}
      </tag>
      <tag v-if="jobTypes.length > 2" color="default">
        +{{ jobTypes.length - 1 }}
      </tag>
    </div>
  </tooltip>
</template>

<script>
export default {
  props: {
    jobTypes: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredJobTypes () {
      return this.jobTypes ? this.jobTypes.slice(0, 1) : []
    },
    tooltipText () {
      return this.jobTypes.join(', ')
    }
  }
}
</script>

<style>

</style>
